import React from 'react';
import STRINGS from 'constants/strings';
import { Profile } from 'components';

const UserLink = ({
    isLoggedIn,
    memberAlias,
    facebookId,
    mouseOver,
    mouseOut,
    handleClickUser,
    threadsUnread
}) => (
    <a
        href="/my/overview"
        rel="nofollow"
        aria-label="Mitt Tradera"
        className={`slim-header__menu-link px-3 d-flex align-items-center ${!isLoggedIn &&
            'slim-header__menu-link--user'}`}
        data-ga-category="Header"
        data-ga-action="Navigation"
        data-ga-label="My Tradera"
        title={isLoggedIn ? memberAlias : STRINGS.LOGIN}
        data-nav-mytradera
        onMouseEnter={mouseOver}
        onMouseLeave={mouseOut}
        onClick={e => handleClickUser(e)}>
        <span className="row d-flex align-items-center align-items-center no-gutters">
            <Profile isLoggedIn={isLoggedIn} facebookId={facebookId} />
            {threadsUnread > 0 && (
                <span
                    className={`slim-header__notification slim-header__notification-user ${
                        facebookId ? 'user__facebook' : ''
                    } d-none d-md-block`}>
                    {threadsUnread}
                </span>
            )}
            <span className="slim-header__link-text slim-header__link-text--user pl-1 d-none d-lg-inline col-auto">
                {isLoggedIn ? memberAlias : STRINGS.LOGIN}
            </span>
            {isLoggedIn && (
                <span
                    className="slim-header__user-menu-icon arrow-down--after ss-fix--after pl-1 col-auto d-none d-md-inline"
                    aria-hidden="true"
                />
            )}
        </span>
    </a>
);

export default UserLink;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/user-link.jsx